// extracted by mini-css-extract-plugin
export default {"registerButtonArea":"CorporationList_registerButtonArea__cIzcF"};